/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioUpdateRequest
 */
export interface PortfolioUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioUpdateRequest
     */
    order?: number;
}

/**
 * Check if a given object implements the PortfolioUpdateRequest interface.
 */
export function instanceOfPortfolioUpdateRequest(value: object): value is PortfolioUpdateRequest {
    return true;
}

export function PortfolioUpdateRequestFromJSON(json: any): PortfolioUpdateRequest {
    return PortfolioUpdateRequestFromJSONTyped(json, false);
}

export function PortfolioUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function PortfolioUpdateRequestToJSON(json: any): PortfolioUpdateRequest {
    return PortfolioUpdateRequestToJSONTyped(json, false);
}

export function PortfolioUpdateRequestToJSONTyped(value?: PortfolioUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'order': value['order'],
    };
}

